import { COLOR_PALETTE } from 'constants/ui';

export const BadgeColorVariant = Object.keys(COLOR_PALETTE).reduce((acc, key) => {
  acc[key] = key;

  return acc;
}, {});

export const BadgeType = {
  SIDEBAR: 'sidebar',
  DOT: 'dot',
};
